import * as React from "react";
import {connect} from "react-redux";
import PatientLeftNav from "../components/patient/PatientLeftNav"
import {PatientCompleteInfoActions} from "../actions/PatientCompleteInfoActions"
import {default as AppUtils, LOADING_STATE} from "../utils/AppUtils"
import * as _ from "lodash";
import IPatientCompleteInfo from "../models/patients/IPatientCompleteInfo"
import {IAppState} from "../models/IAppState"
import AppLoader from "../components/utils/AppLoader";
import { AppConstants, ORION_IMG_URL } from "../utils/AppConstants";

/**
 * Created by abhinav on 26/01/18.
 */

export interface PatientContainerProps {
    routeParams?: any,
    patientCompleteInfo: IPatientCompleteInfo;
    fetchPatientCompleteDetails: (patientId: number) => any;
    fetchPatientAppointments: (patientId: number) => any;
    clearPatientCompleteDetails: (patientId: number) => any;
    fetchPatientPersonalInfo: (curefitId: string, patientId: number, isSelf: boolean) => any;
    fetchPatientTypeFormData: (patientId: number) => any;
    params: any;
}

export interface PatientContainerState {
    patientDetailsLoadingState: LOADING_STATE,
    patientCompleteInfoLoadingState: LOADING_STATE,
    typeFormDataLoadingState: LOADING_STATE,
    patientPersonalInfoLoadingState: LOADING_STATE
}

class PatientContainer extends React.Component<PatientContainerProps, PatientContainerState> {

    constructor(props: PatientContainerProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    };

    getPatientId = (nextProps?: PatientContainerProps) => {
        if (nextProps && nextProps.params.patientId) {
            return parseInt(nextProps.params.patientId);
        }
        return parseInt(this.props.params.patientId);
    }

    getAppointmentId = () => {
        if (this.props && this.props.params && this.props.params.consultationId) {
            return this.props.params.consultationId
        }
        return null
    }

    getStateFromProps = (currProps: PatientContainerProps) => {
        let patientDetailsLoadingState = !_.isEmpty(this.state) && this.state.patientDetailsLoadingState !== undefined ? this.state.patientDetailsLoadingState : LOADING_STATE.NOT_INITIALIZED;
        let patientCompleteInfoLoadingState = !_.isEmpty(this.state) && this.state.patientCompleteInfoLoadingState !== undefined ? this.state.patientCompleteInfoLoadingState : LOADING_STATE.NOT_INITIALIZED;
        let typeFormDataLoadingState = !_.isEmpty(this.state) && this.state.typeFormDataLoadingState !== undefined ? this.state.typeFormDataLoadingState : LOADING_STATE.NOT_INITIALIZED;
        let patientPersonalInfoLoadingState = !_.isEmpty(this.state) && this.state.patientPersonalInfoLoadingState ? this.state.patientPersonalInfoLoadingState : LOADING_STATE.NOT_INITIALIZED;
        let patientId = parseInt(this.props.params.patientId);

        if (!_.isEmpty(currProps.patientCompleteInfo) &&
            !_.isEmpty(currProps.patientCompleteInfo.profile) &&
            !_.isNull(currProps.patientCompleteInfo.personalInfo) &&
            !_.isNull(currProps.patientCompleteInfo.typeFormData) &&
            currProps.patientCompleteInfo.profile.id === patientId) {
                    patientDetailsLoadingState = LOADING_STATE.LOADED;
                    patientCompleteInfoLoadingState = LOADING_STATE.LOADED;
                    typeFormDataLoadingState = LOADING_STATE.LOADED;
                    patientPersonalInfoLoadingState = LOADING_STATE.LOADED;
        } else {
            if (_.isEmpty(currProps.patientCompleteInfo.profile) && patientCompleteInfoLoadingState === LOADING_STATE.NOT_INITIALIZED) {
                patientCompleteInfoLoadingState = LOADING_STATE.LOADING;
                this.props.fetchPatientCompleteDetails(patientId);
            }

            if (_.isEmpty(currProps.patientCompleteInfo.typeFormData) && typeFormDataLoadingState === LOADING_STATE.NOT_INITIALIZED) {
                typeFormDataLoadingState = LOADING_STATE.LOADING;
                this.props.fetchPatientTypeFormData(patientId);
            }

            if (!_.isEmpty(currProps.patientCompleteInfo) && !_.isEmpty(currProps.patientCompleteInfo.profile)
                && _.isNull(currProps.patientCompleteInfo.personalInfo)
                && patientPersonalInfoLoadingState === LOADING_STATE.NOT_INITIALIZED) {
                    patientPersonalInfoLoadingState = LOADING_STATE.LOADING;
                    let { curefitUserId } = currProps.patientCompleteInfo.profile;
                let isSelf = currProps.patientCompleteInfo.profile.relationship && currProps.patientCompleteInfo.profile.relationship.toUpperCase() === AppConstants.patientRelationships.SELF;
                    // let userId = AppUtils.getPolarisUserId(this.getPatientId(), curefitUserId, isSelf);
                    this.props.fetchPatientPersonalInfo(curefitUserId, this.getPatientId(), isSelf);
            }
        }

        return {
            patientDetailsLoadingState: patientDetailsLoadingState,
            patientCompleteInfoLoadingState,
            typeFormDataLoadingState,
            patientPersonalInfoLoadingState
        }
    }

    fetchPatientPersonalInfo = (patientCompleteInfo: IPatientCompleteInfo, patientId: number) => {
        const {curefitUserId} = patientCompleteInfo.profile;
        const isSelf = patientCompleteInfo.profile.relationship && patientCompleteInfo.profile.relationship.toUpperCase() === AppConstants.patientRelationships.SELF;
        this.props.fetchPatientPersonalInfo(curefitUserId, patientId, isSelf);
    };

    componentWillReceiveProps(nextProps: PatientContainerProps) {
        if (this.props.routeParams.patientId !== nextProps.routeParams.patientId || this.props.routeParams.consultationId !== nextProps.routeParams.consultationId) {
            this.props.clearPatientCompleteDetails(this.getPatientId());
            this.props.fetchPatientCompleteDetails(nextProps.routeParams.patientId)
            this.fetchPatientPersonalInfo(nextProps.patientCompleteInfo, this.getPatientId(nextProps));
        } else {
            this.setState(this.getStateFromProps(nextProps))
        }
    }

    componentWillUnmount() {
        this.props.clearPatientCompleteDetails(this.getPatientId());
    }

    render() {
        let isPatientDataLoaded = this.state.patientDetailsLoadingState === LOADING_STATE.LOADED;
        if (isPatientDataLoaded)
            return (
                isPatientDataLoaded &&
                <div className="patient-container">

                    {this.props.patientCompleteInfo.profile ? <PatientLeftNav patient={this.props.patientCompleteInfo.profile} appointmentId={this.getAppointmentId()}/> : null}

                    <div className="patient-right-nav">
                        {this.props.children}
                    </div>

                </div>
            )
        else
            return <div className="central-loader ongoing-consultation-cont-loader">
                <img src={ORION_IMG_URL + "loader/curefit-loader.gif"}/>
            </div>
    }
}

function mapStateToProps (state: IAppState, ownProps: PatientContainerProps): any {
    return {
        patientCompleteInfo: state.patientCompleteInfo,
        params: ownProps.params
    };
}

function mapDispatchToProps(dispatch: any): any {
    return {
        fetchPatientCompleteDetails: (patientId: number) => {
            PatientCompleteInfoActions.fetchPatientCompleteDetails(dispatch, patientId);
        },
        fetchPatientPersonalInfo: (curefitId: number, patientId: number, isSelf: boolean) => {
            PatientCompleteInfoActions.fetchPatientPersonalInformation(dispatch, curefitId, patientId, isSelf);
        },
        fetchPatientAppointments: (patientId: number) => {

        },
        clearPatientCompleteDetails: (patientId: number) => {
            PatientCompleteInfoActions.clearPatientCompleteDetails(dispatch, patientId);
        },
        fetchPatientTypeFormData: (patientId: number) => {
            PatientCompleteInfoActions.fetchPatientTypeFormData(dispatch, patientId);
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientContainer);
